import script from "./MobileAd.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileAd.vue?vue&type=script&setup=true&lang=ts"

import "./MobileAd.vue?vue&type=style&index=0&id=796462af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796462af"]])

export default __exports__